import { render, staticRenderFns } from "./ResetConfiguration.vue?vue&type=template&id=1e452344&scoped=true&"
import script from "./ResetConfiguration.vue?vue&type=script&lang=js&"
export * from "./ResetConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e452344",
  null
  
)

export default component.exports